import { NavLink } from "react-router";

function Footer() {
    return (
        <footer className="footer">
            <div className="footer_content">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 footer_col">
                            <div className="footer_about">
                                {/* <div>
                                    <a href="#">
                                        <div className="logo_container d-flex flex-row align-items-start justify-content-start">
                                            <div className="logo_image"><div><img src="images/logo.png" alt=""/></div></div>
                                            <div className="logo_content">
                                                <div id="logo_text" className="logo_text logo_text_not_ie">The Conference</div>
                                                <div className="logo_sub">August 25, 2018 - Miami Marina Bay</div>
                                            </div>
                                        </div>
                                    </a>
                                </div> */}
                                <div className="footer_about_text">
                                    <p>Contact: contact@ietbhec.com</p>
                                    <p>Copyright © International Engineering and Technology Education Conference (IETEC)</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer